export const CHECK_AUTH = 'checkAuth'
export const LOGIN = 'login'
export const USER_LOGIN = 'userLogin'
export const USER_PHONE_LOGIN = 'userPhoneLogin'
export const USER_EMAIL_LOGIN = 'userEmailLogin'
export const USER_LOGOUT = 'userLogout'
export const LOGOUT = 'logout'
export const FORGOT = 'forgot'
export const REGISTER = 'register'
export const UPDATE_USER = 'updateUser'
export const UPDATE_USER_CONSENT = 'updateUserConsent'
export const USER_INFO = 'userInfo'
export const USER_CONSENT = 'userConsent'
export const REG_STATUS = 'regStatus'
export const CONFIRM_COMMUNICATION = 'confirmCommunication'
export const CONFIRM_MERGE = 'confirmMerge'
export const RESET_ERRORS = 'resetErrors'
export const CONFIRM_EMAIL = 'confirmEmail'
export const SEND_CONFIRMATION_CODE = 'sendConfirmationCode'
export const GET_PROMO = 'getPromo'
export const SET_PROMO = 'setPromo'
export const UPLOAD_CHECK = 'uploadCheck'
export const GET_CHECKS = 'getChecks'
export const UPLOAD_COUPON = 'uploadCoupon'
export const CHECK_USER_AUTH = 'checkUserAuth'
export const SET_USER_QUESTIONNAIRE = 'setUserQuestionnaire'



// WEBPACK FOOTER //
// ./src/store/actions.type.js